import { Component, Input, OnInit } from '@angular/core';
import { IframeModel, SetIFrame } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-sample-iframe',
  templateUrl: './sample-iframe.component.html',
  styleUrls: ['./sample-iframe.component.scss']
})
export class SampleIframeComponent implements OnInit {

  @Input() block: SetIFrame = {} as SetIFrame;

  public objIframe: IframeModel = {} as IframeModel;
  private atributeName: string[] = ['width', 'height', 'src', 'style', 'allow', 'class'];

  constructor(private helperService: HelpersService) { }

  ngOnInit(): void {
    this.splitMethod();
  }

  splitMethod() {
    let iframe = this.helperService.retrieveIframe(this.block.codice_iframe);
    if (iframe) {
      iframe = iframe.children[0];
      for (const tag of this.atributeName) {
        if (iframe.attribs[tag]) {
          this.objIframe = {
            ...this.objIframe,
            [tag]: iframe.attribs[tag]
          }
        }
      }
    }
  }

}
